// extracted by mini-css-extract-plugin
module.exports = {"form":"ChangePaymentTypes_form__3klVz","actions":"ChangePaymentTypes_actions__3QVLa"};